/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import {Utils} from '../../utils/api';
import {deepGet} from '../../utils/api/Utils';
import {SortPopUp, ArrowUp, RadiosContainer, CheckBoxWrapper, PopUpText} from './styles';
import {Radio, InputCheckbox} from '../';
import {Oval} from '../../pages/players/styles';

interface PropsPopover {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
}

export const Popover = ({table, useTable, data, visible, popup_id, includeAlerts, status}: PropsPopover) => {
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const sortOptions = [reverse, useTable, table];
  const [firstRender, useFirstRender] = useState<boolean>(true);
  const [radio, useRadio] = useState<any>({one: false, two: false});
  const [check, useCheck] = useState<any>({zone_2: false, zone_1: false});

  useEffect(() => {
    if (!firstRender) {
      UTILS.HandleSorted(data, sortOptions);
    } else {
      useFirstRender(!firstRender);
    }
    
    if (status) buildFilter();
  }, [radio]);

  useEffect(() => {
    if (status) buildFilter();
  }, [check]);

  const buildFilter = () => {
    let filters: Array<string> = [];
    Object.values(check)?.map((item, idx) => {
      if (item) filters.push(Object.keys(check)[idx]);

      return item;
    });
    filters = filters?.map(item => {
      if (item === 'zone_2') item = 'zone 2';

      if (item === 'zone_1') item = 'zone 1';

      return item;
    });

    useTable(
      table.filter(item => {
        let pass = false;
        const statusValue = filters?.map(filterValue => {
          return deepGet(item, status) === filterValue;
        });
        statusValue?.map(val => {
          if (val) pass = true;

          return val;
        });
        if (filters?.length === 0) pass = true;

        return pass;
      }),
    );
  };

  const HandleRadioSort = (e: any): void => {
    if (e?.target?.id === 'descendent') {
      const descendent = {one: true, two: false};
      useReverse(false);
      useRadio(descendent);
    } else if (e?.target?.id === 'ascendent') {
      const ascendent = {one: false, two: true};
      useReverse(true);
      useRadio(ascendent);
    }
  };  

  return (
    <>
      {visible === popup_id && (
        <SortPopUp>
          <ArrowUp />
          <RadiosContainer onChange={HandleRadioSort}>
            <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
            <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
          </RadiosContainer>
          {includeAlerts && (
            <>
              <hr style={{border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px'}} />

              <CheckBoxWrapper>
                <InputCheckbox checked={check.zone_2} onClick={() => useCheck({...check, zone_2: !check.zone_2})} />
                <PopUpText onClick={() => useCheck({...check, zone_2: !check.zone_2})}>Warning</PopUpText>
                <Oval size={'16'} color={'red'} />
              </CheckBoxWrapper>
              <CheckBoxWrapper>
                <InputCheckbox checked={check.zone_1} onClick={() => useCheck({...check, zone_1: !check.zone_1})} />
                <PopUpText onClick={() => useCheck({...check, zone_3: !check.zone_1})}>Watch</PopUpText>
                <Oval size={'16'} color={'yellow'} />
              </CheckBoxWrapper>
            </>
          )}
        </SortPopUp>
      )}
    </>
  );
};
